import type { NightEvent, DayEvent, SheriffClaim, PlayerAssignment } from '../../types/game';
import { GameTimeline } from './GameTimeline';

interface ZoneBCenterProps {
  nights: NightEvent[];
  days: DayEvent[];
  sheriffClaims: SheriffClaim[];
  assignments: PlayerAssignment[];
  focusedSeat: number | null;
  visibleDay: number;
}

export function ZoneB_Center({
  nights,
  days,
  sheriffClaims,
  assignments,
  focusedSeat,
  visibleDay,
}: ZoneBCenterProps) {
  return (
    <div className="min-w-0 overflow-y-auto max-h-[80vh] pr-1">
      <GameTimeline
        nights={nights}
        days={days}
        sheriffClaims={sheriffClaims}
        assignments={assignments}
        focusedSeat={focusedSeat}
        visibleDay={visibleDay}
      />
    </div>
  );
}
